import DateInput from "./DateInput.vue";
import { pluginify } from "./../../util";
export default pluginify(DateInput);
export { DateInput };
